var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgRatingActive = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: "1em",
  height: "1em",
  viewBox: "0 0 8 8",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M4 6 2.008 7.047a.2.2 0 0 1-.29-.21l.38-2.219L.486 3.047a.2.2 0 0 1 .11-.341l2.228-.324.997-2.019a.2.2 0 0 1 .358 0l.997 2.019 2.227.324a.2.2 0 0 1 .111.34L5.902 4.619l.38 2.219a.2.2 0 0 1-.29.21L4 6Z",
  fill: "#87888B",
  fillRule: "evenodd"
})));
export default SvgRatingActive;